module.exports = __webpack_public_path__ + "img/layers.c1a8c567.svg";